import React from "react";
import {
  Wallet, Briefcase, Home, HeartPulse, Brain, Users, Scale, Shield, Zap, Target,
  MessageCircle, Flag, Rocket, Footprints, Gamepad2, Flame, TrendingUp, Sparkles,
  Trophy, PiggyBank, Utensils, Handshake, FileText, Mic, Activity, Smile, CreditCard,
  Star, BookOpen, Layers, ListChecks, HelpCircle, Play, GraduationCap,
} from "lucide-react";

const MAP = {
  wallet: Wallet, briefcase: Briefcase, home: Home, "heart-pulse": HeartPulse, brain: Brain,
  users: Users, scale: Scale, shield: Shield, zap: Zap, target: Target,
  "message-circle": MessageCircle, flag: Flag, rocket: Rocket, footprints: Footprints,
  "gamepad-2": Gamepad2, flame: Flame, "trending-up": TrendingUp, sparkles: Sparkles,
  trophy: Trophy, "piggy-bank": PiggyBank, utensils: Utensils, handshake: Handshake,
  "file-text": FileText, mic: Mic, activity: Activity, smile: Smile, "credit-card": CreditCard,
  star: Star, book: BookOpen, layers: Layers, checklist: ListChecks, quiz: HelpCircle,
  play: Play, graduation: GraduationCap,
};

export default function Icon({ name, className, size = 24, strokeWidth = 2 }) {
  const C = MAP[name] || Sparkles;
  return <C className={className} size={size} strokeWidth={strokeWidth} />;
}
